<template>
  <div :class="`flex flex-col accordion-container relative`">
    <div :class="`flex flex-col relative cursor-pointer ${className}`" @click="toggle">
      <slot name="title">
        <div class="flex items-center justify-between p-4">
          <p class="text-5 font-bold title">{{ title }}</p>

          <component :is="getIcon" class="arrow" :data-toggle="toggleAccordion" />
        </div>
      </slot>

      <div :style="`height: ${contentHeight}px`" class="flex-shrink-0 overflow-hidden accordion-content">
        <div ref="contentRef" class="flex flex-col">
          <div v-if="showDivider" class="flex-shrink-0 self-stretch bg-light-gray divider mb-4" />
          <slot name="content">
            <p class="px-4 mb-6 text-dark-gray content">{{ content }}</p>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconExpandRight from '@/components/icons/IconExpandRight.vue'

export default {
  name: 'AccordionComponent',
  components: { IconExpandRight },
  props: {
    title: { type: String, default: '' },
    content: { type: String, default: '' },
    className: { type: String, default: '' },
    showDivider: { type: Boolean, default: true },
    preventToggle: { type: Boolean, default: false },
    isOpened: { type: Boolean, default: false },
    icon: { type: Object, default: null }
  },
  expose: ['setAccordionVisible'],
  data() {
    return {
      toggleAccordion: false,
      contentHeight: 0,
      resizeObserver: new ResizeObserver(this.onContentChanged)
    }
  },
  computed: {
    getIcon() {
      return this.icon || IconExpandRight
    }
  },
  watch: {
    isOpened(value) {
      this.toggleAccordion = value
    },
    toggleAccordion(value) {
      const contentHeight = this.$refs.contentRef.offsetHeight

      if (value) {
        this.contentHeight = contentHeight
      } else {
        this.contentHeight = 0
      }
    }
  },
  mounted() {
    this.resizeObserver.observe(this.$refs.contentRef)
  },
  methods: {
    toggle() {
      if (this.preventToggle) return null

      this.toggleAccordion = !this.toggleAccordion
    },
    onContentChanged() {
      if (this.$refs.contentRef) {
        const contentHeight = this.$refs.contentRef.offsetHeight

        if (this.toggleAccordion) {
          this.contentHeight = contentHeight
        }
      }
    },
    setAccordionVisible(visible) {
      this.toggleAccordion = visible
    }
  }
}
</script>

<style lang="scss">
.accordion-container {
  .arrow {
    height: 1.5rem;
    width: 1.5rem;
    transform: rotate(90deg);
    transition-property: transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 250ms;
    flex-shrink: 0;

    &[data-toggle='true'] {
      transform: rotate(-90deg);
    }
  }

  .divider {
    height: 2px;
    background: var(--neutro-30, #e6e8e8);
  }

  .accordion-content {
    transition-property: height;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 250ms;

    .content {
      font-size: 1.125rem;
    }
  }
}
</style>
